/**
 * 软限制：拦截常见打开开发者工具的方式（F12、部分快捷键、右键菜单）。
 * 无法从技术上阻止用户调试，仅作轻度防护与提示。
 *
 * 关闭限制的方式（任一即可）：
 * - 地址栏参数：?debug=1 或 ?devtools=1 或 ?allowF12=1（同一标签页内会写入 sessionStorage，去掉参数后仍有效直至关闭标签）
 * - ?nodebug=1 清除上述 session 记忆并恢复限制
 * - 构建环境变量：VUE_APP_ALLOW_DEVTOOLS=true（整包不启用限制）
 * - 开发模式 (npm run serve) 默认不限制；若要本地也测限制：VUE_APP_FORCE_DEVTOOLS_GUARD=true
 *
 * 「卡死」式干扰（仅在不放行调试时启用）：
 * - 定时执行 debugger：开发者工具打开且未关闭「在遇到 debugger 语句时暂停」时，会持续断住，页面像卡住。
 * - 定时 console.clear：清空控制台，日志不易看。
 * 对方若在 Sources 里关掉断点/停用断点，或改用远程调试，仍可绕过。
 *
 * 可选环境变量：
 * - VUE_APP_DEVTOOLS_DEBUGGER_INTERVAL_MS：debugger 间隔毫秒，默认 350
 * - VUE_APP_DEVTOOLS_NO_CONSOLE_CLEAR=true：不清控制台
 * - VUE_APP_DEVTOOLS_CLEAR_INTERVAL_MS：清控制台间隔，默认 2200
 */

const SESSION_KEY = 'HK_ALLOW_DEVTOOLS'

const TRUTHY = new Set(['1', 'true', 'yes', 'on'])

function searchParams() {
  if (typeof window === 'undefined') return null
  return new URLSearchParams(window.location.search)
}

function paramAllowsDevtools(qs) {
  if (!qs) return false
  const keys = ['debug', 'devtools', 'allowF12']
  for (const k of keys) {
    const v = (qs.get(k) || '').toLowerCase()
    if (v && TRUTHY.has(v)) return true
  }
  return false
}

export function isDevtoolsAllowed() {
  if (typeof window === 'undefined') return true

  const qs = searchParams()
  if (qs) {
    const off = (qs.get('nodebug') || '').toLowerCase()
    if (off && TRUTHY.has(off)) {
      sessionStorage.removeItem(SESSION_KEY)
    }
  }

  if (process.env.VUE_APP_ALLOW_DEVTOOLS === 'true') return true

  if (paramAllowsDevtools(qs)) {
    sessionStorage.setItem(SESSION_KEY, '1')
    return true
  }

  if (sessionStorage.getItem(SESSION_KEY) === '1') return true

  if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_FORCE_DEVTOOLS_GUARD !== 'true') {
    return true
  }

  return false
}

function onKeyDown(e) {
  if (e.key === 'F12') {
    e.preventDefault()
    e.stopPropagation()
    return
  }
  if (e.ctrlKey && e.shiftKey) {
    const k = e.key
    if (k === 'I' || k === 'J' || k === 'C' || k === 'K') {
      e.preventDefault()
      e.stopPropagation()
    }
  }
  if (e.ctrlKey && !e.shiftKey && (e.key === 'u' || e.key === 'U')) {
    e.preventDefault()
    e.stopPropagation()
  }
}

function onContextMenu(e) {
  e.preventDefault()
}

let installed = false
let debuggerTimerId = 0
let consoleClearTimerId = 0

function parsePositiveInt(v, fallback) {
  const n = Number.parseInt(String(v), 10)
  return Number.isFinite(n) && n > 0 ? n : fallback
}

function startDebuggerSpam() {
  const ms = parsePositiveInt(process.env.VUE_APP_DEVTOOLS_DEBUGGER_INTERVAL_MS, 350)
  debuggerTimerId = window.setInterval(() => {
    // 仅在打开 DevTools 且允许在 debugger 处暂停时才会真正卡住主线程
    // eslint-disable-next-line no-debugger
    debugger
  }, ms)
}

function startConsoleClearSpam() {
  if (process.env.VUE_APP_DEVTOOLS_NO_CONSOLE_CLEAR === 'true') return
  const ms = parsePositiveInt(process.env.VUE_APP_DEVTOOLS_CLEAR_INTERVAL_MS, 2200)
  consoleClearTimerId = window.setInterval(() => {
    try {
      if (typeof console !== 'undefined' && typeof console.clear === 'function') {
        console.clear()
      }
    } catch (e) {
      /* ignore */
    }
  }, ms)
}

export function installDevtoolsGuard() {
  if (installed) return
  if (isDevtoolsAllowed()) return

  installed = true
  window.addEventListener('keydown', onKeyDown, true)
  document.addEventListener('keydown', onKeyDown, true)
  document.addEventListener('contextmenu', onContextMenu, true)

  startDebuggerSpam()
  startConsoleClearSpam()
}
